module.exports = __webpack_public_path__ + "img/MASTER_CHN_VP_Handbook_Web26.33b40a71.jpg";